var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-background",class:{'loading-background--visible': _vm.show > 0}},[_c('div',{staticClass:"loading-background__inner"},[_c('img',{staticClass:"loading-background__gif",attrs:{"src":'/images/leadance.gif'}})])])}
var staticRenderFns = []

export { render, staticRenderFns }